const childRoutes = prop => [
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/Dashboard.vue')
    },
    {
        path: 'data-collection',
        name: prop + '.data_collection',
        meta: { auth: true },
        component: () => import('../pages/data-collection/List.vue')
    },
    {
        path: 'user-privilege-form',
        name: prop + '.user_privilege',
        meta: { auth: true },
        component: () => import('../pages/user-privilege/Form.vue')
    }
]
const routes = [
    {
        path: '/rehabilitation-vagrant-service/configuration',
        name: 'rehabilitation_vagrant_service.configuration',
        component: () => import('@/layouts/RehabilitationVagrantService.vue'),
        meta: { auth: true },
        children: childRoutes('rehabilitation_vagrant_service.configuration')
    }
]

export default routes
